import { Icon, Text } from '@kanda-libs/ks-design-library';

export interface StepDisplayProps {
  number: number;
  isPassed: boolean;
  isLoading: boolean;
}

const StepDisplay: React.FunctionComponent<StepDisplayProps> = function ({
  number,
  isPassed,
  isLoading,
}) {
  if (isPassed)
    return (
      <Icon
        icon="check"
        size={16}
        stroke="neutral-000"
        className="m-auto"
        isLoading={isLoading}
      />
    );
  return (
    <Text
      className="m-auto text-neutral-000"
      text={String(number)}
      isLoading={isLoading}
    />
  );
};

export default StepDisplay;
